// extracted by mini-css-extract-plugin
export default {"mf_add_composition":"MfAddComposition_mf_add_composition__DWIPC","select_tab":"MfAddComposition_select_tab__L8ohE","active":"MfAddComposition_active__Rpxnn"};